export const tr = {
  __currency_code__: "TRY",
  __currency__: "TL",
  __currency_symbol__: "₺",
  __locale__: "tr-TR",

  "2d": "2D",
  "3d": "3D",
  viewMode2dPlan: "2D Plan",
  viewMode3dView: "3D Görünüm",
  viewModeToggleLabel: "Görünüm modu",
  fitCameraTip: "Sahneye sığdır",
  zoomIn: "Yakınlaştır",
  zoomOut: "Uzaklaştır",
  grid: "Izgara",
  rapidPlanner: "RapidPlanner",
  save: "Kaydet",
  saveDisabledTip: "Kaydetme yakında kullanılabilir",
  myRenders: "Renderlarım",
  myRendersHint: "Son alınan render görselleriniz",
  myRendersEmpty: "Henüz kayıtlı render yok. 3D modundan bir görünüm yakalayın.",
  myRendersCapture: "Görünümü ekle",
  myRendersCapturing: "Ekleniyor…",
  rendersTabMy: "Renderlarım",
  rendersTabRapid: "RapidRender",
  rapidRendersEmpty: "Henüz RapidRender görseli yok.",
  rapidRendersLoading: "Renderlar yükleniyor…",
  rapidRendersPending: "Render alınıyor…",
  rapidRendersError: "Render başarısız.",
  rapidRendersLoadMore: "Daha fazla yükle",
  renderCapture: "AI Render",
  renderCapturing: "Render alınıyor…",
  aiRenderTitle: "AI Render",
  aiRenderHint: "İstediğiniz görünümü yazın, ardından render’ı başlatın.",
  aiRenderPrompt: "Prompt",
  aiRenderPromptPlaceholder:
    "örn. yumuşak gün ışığı, sıcak ahşap tonları, samimi oturma odası…",
  aiRenderResolution: "Çözünürlük",
  aiRenderPersonalize: "Kişiselleştir",
  aiRenderAddPlant: "Bitki ekle",
  aiRenderAddArtwork: "Sanat eseri",
  aiRenderAddDecor: "Dekor ekle",
  aiRenderStart: "Render başlat",
  aiRenderProgressTitle: "Render hazırlanıyor",
  aiRenderProgressWorking: "Çalışıyor…",
  aiRenderProgressBeauty: "Görünüm yakalanıyor",
  aiRenderProgressAlbedo: "Albedo yakalanıyor",
  aiRenderProgressTopView: "Üst görünüm yakalanıyor",
  aiRenderProgressNormal: "Normal yakalanıyor",
  aiRenderProgressDepth: "Depth yakalanıyor",
  aiRenderProgressSend: "RapidRender’a gönderiliyor",
  sceneAiTitle: "Sahne AI",
  sceneAiSettings: "API ayarları",
  sceneAiProvider: "Sağlayıcı",
  sceneAiModel: "Model",
  sceneAiSearchModel: "Model ara…",
  sceneAiNoModels: "Eşleşen model yok. Yine de bu adı kullanabilirsiniz.",
  sceneAiApiKey: "API anahtarı",
  sceneAiEmpty: "Daireyi veya odayı tarif edin. AI kat planını, odaları ve mobilyayı yerleştirir.",
  sceneAiPlaceholder: "örn. 110 m², 2+1, açık mutfak, giriş güneyden…",
  sceneAiAttachImage: "Fotoğraf ekle",
  sceneAiRemoveImage: "Fotoğrafı kaldır",
  sceneAiDropImage: "Fotoğrafı buraya bırakın",
  sceneAiSend: "Gönder",
  sceneAiSending: "Gönderiliyor…",
  sceneAiNeedKey: "Önce API anahtarını ayarlardan girin.",
  sceneAiThinking: "Düşünce",
  sceneAiTool: "Araç",
  sceneAiYes: "Evet, uygula",
  sceneAiNo: "Hayır",
  sceneAiBrief: "Brief",
  sceneAiBriefHard: "zorunlu",
  sceneAiBriefSoft: "tercih",
  sceneAiBriefAssume: "varsayım",
  sceneAiBriefUnknown: "soru",
  sceneAiBriefOpen: "açık",
  sceneAiBriefOk: "Sağlandı",
  sceneAiBriefFail: "Sağlanmadı",
  sceneAiBriefUnchecked: "Ölçülmedi",
  authLoginTitle: "Giriş yap",
  authLoginSubtitle: "Bu işlem için giriş yapın.",
  authEmail: "E-posta",
  authPassword: "Şifre",
  authSignIn: "Giriş yap",
  authSigningIn: "Giriş yapılıyor…",
  authCancel: "İptal",
  authSelectCompany: "Şirket seçin",
  authErrorInvalid: "E-posta veya şifre hatalı.",
  authErrorRecaptcha: "Lütfen Ben Robot Değilim kutusunu işaretleyin.",
  authErrorGeneric: "Giriş yapılamadı. Tekrar deneyin.",
  authLogout: "Çıkış yap",
  authAccount: "Hesap",
  pathTraceRender: "Render",
  download: "İndir",
  share: "Paylaş",
  close: "Kapat",
  //SugarModelViewer / material panel
  viewerCustomize: "Özelleştirme",
  viewerPartFabricSelection: "Parça & kumaş seçimi",
  viewerPanelNote:
    "Final renk üretim partilerine göre değişiklik gösterebilir. Numune talebi için Teklif Al butonunu kullanın.",
  viewerClose: "Kapat",
  viewerAR: "AR",
  viewerQrTitle: "Evinizde Görün",
  viewerQrInformText:
    "*Bu özelliği kullanabilmek için arttırılmış gerçeklik destekleyen akıllı telefona ihtiyacınız var.*",
  viewer3dDownload: "3D İndir",
  viewerGetQuote: "Teklif Al",
  viewerToolbar: {
    materials: "Malzemeler",
    dimensions: "Ölçüler",
    help: "Yardım",
    gallery: "Görseller",
    share: "Paylaş",
    fullscreen: "Tam ekran",
    exitFullscreen: "Tam ekrandan çık",
    pathTrace: "Path Trace",
    pathTraceSettings: "Path Trace ayarları",
  },
  download3d: {
    defaultModel: "Model",
    dialogLabel: "3D model indirme talebi",
    badge: "3D Model İndirme",
    title: "Modelleri kullanmak için bize talep iletin.",
    subtitle: "3ds Max, SketchUp, Revit gibi platformlarda kullanım için.",
    configuration: "Konfigürasyon",
    notice:
      "Model indirme talebiniz onaylandığında, mail ile bilgilendirme yapılacaktır.",
    supportedFormats: "Desteklenen formatlar: FBX · GLB · BLEND",
    exportFormats: "Dosya formatları",
    formatRequired: "En az bir dosya formatı seçin.",
    format: {
      fbx: "FBX (3ds Max, Maya)",
      glb: "GLB (glTF)",
      blend: "Blender (BLEND)",
    },
    firstName: "Ad",
    lastName: "Soyad",
    email: "E-posta",
    phone: "Telefon",
    phoneCountryCode: "Telefon ülke kodu",
    projectCountry: "Proje Ülkesi",
    projectCity: "Proje Şehri",
    selectCountry: "Ülke seçin",
    selectCountryFirst: "Önce ülke seçin",
    cityPlaceholder: "Şehir girin",
    company: "Firma / Stüdyo",
    note: "Not",
    submit: "Talep Gönder",
    verifyAndSubmit: "Doğrula ve İndirme Talebi Gönder",
    otpCode: "Doğrulama kodu",
    otpTitle: "Doğrulama kodunu girin",
    otpPlaceholder: "000000",
    otpHint: "Telefonunuza gönderilen 6 haneli kodu girin.",
    otpResend: "Yeni kod gönder",
    otpBack: "Bilgileri düzenle",
    otpResendHint: 'Yeni bir kod almak için "Yeni kod gönder"e tıklayın.',
    otpRequired: "Lütfen doğrulama kodunu girin.",
    validationError: "Lütfen zorunlu alanları doldurun.",
    unexpectedResponse: "Beklenmeyen sunucu yanıtı.",
    rateLimit:
      "Çok fazla deneme yaptınız. Lütfen bir süre sonra tekrar deneyin.",
    genericError: "İndirme talebi gönderilemedi. Lütfen tekrar deneyin.",
    successTitle: "İndirme talebiniz alındı",
    successSubtitle:
      "Talebiniz onaylandığında e-posta ile bilgilendirileceksiniz.",
    successDismissHint: "Pencere birkaç saniye içinde kapanacak.",
  },
  quoteRequest: {
    dialogLabel: "Teklif talebi",
    badge: "Avantajlı Fiyatlar",
    title: "Talebinizi iletin, 1 iş günü içinde sizlere dönelim.",
    subtitle:
      "Konfigürasyonunuza özel avantajlı fiyat teklifimizi hızlıca paylaşıyoruz.",
    quantity: "Adet",
    decreaseQuantity: "Adedi azalt",
    increaseQuantity: "Adedi artır",
    details: "Talep detayı",
    detailsPlaceholder: "Kumaş, renk, teslimat zamanı, özel notlar...",
    submit: "Teklif Talebi Gönder",
    contactMethod: "Doğrulama kanalı",
    contactPhone: "Telefon (SMS)",
    contactEmail: "E-posta",
    verifyAndSubmit: "Doğrula ve Teklif Talebi Gönder",
    otpCode: "Doğrulama kodu",
    otpTitle: "Doğrulama kodunu girin",
    otpPlaceholder: "000000",
    otpHint: "Seçtiğiniz kanala gönderilen 6 haneli kodu girin.",
    otpResend: "Yeni kod gönder",
    otpBack: "Bilgileri düzenle",
    otpResendHint: 'Yeni bir kod almak için "Yeni kod gönder"e tıklayın.',
    otpRequired: "Lütfen doğrulama kodunu girin.",
    validationError: "Lütfen zorunlu alanları doldurun.",
    unexpectedResponse: "Beklenmeyen sunucu yanıtı.",
    rateLimit:
      "Çok fazla deneme yaptınız. Lütfen bir süre sonra tekrar deneyin.",
    genericError: "Teklif talebi gönderilemedi. Lütfen tekrar deneyin.",
    successTitle: "Teklif talebiniz alındı",
    successSubtitle: "Teklif numaranız:",
    successDismissHint: "Pencere birkaç saniye içinde kapanacak.",
  },
  roomQuote: {
    tip: "Teklif Al",
    sceneSummary: "Sahne ürünleri",
    productsLabel: "Sahnedeki ürünler",
    emptyScene: "Teklif göndermek için sahnede en az bir ürün olmalı.",
    categoryCountBlockedTitle: "Teklif için adet uygun değil",
    categoryCountBlocked:
      "Sahnedeki {{category}} sayısı {{multiple}} sayısının katı olmalı. Teklif için adedi buna göre düzeltin.",
    missingCompany: "Teklif için şirket bilgisi bulunamadı. Kataloğu kontrol edin.",
    fullName: "İsim Soyisim",
    phone: "Telefon",
    headline:
      "Tasarımınızı yazdırın veya avantajlı fiyatlarla teklif alın.",
    submit: "Teklif Al",
    contactRequired: "Lütfen isim soyisim ve telefon girin.",
    draftSaved: "Bilgileriniz kaydedildi. Teklif formuna yönlendiriliyorsunuz…",
    sku: "SKU",
  },
  viewerApiErrors: {
    RATE_LIMIT:
      "Çok fazla deneme yaptınız. Lütfen bir süre sonra tekrar deneyin.",
    ORIGIN_DENIED: "Bu site üzerinden işlem yapılamıyor.",
    CHANNEL_NOT_FOUND: "Bu şirket için hizmet yapılandırılmamış.",
    VALIDATION_ERROR: "Girdiğiniz bilgileri kontrol edin.",
    OTP_FAILED: "Doğrulama kodu geçersiz veya süresi dolmuş.",
    ACCESS_DENIED: "Bu işlem için yetkiniz yok.",
    MISSING_PUBLIC_KEY: "Teklif entegrasyonu yapılandırması eksik.",
    CRM_VALIDATION: "İstek işlenemedi. Bilgilerinizi kontrol edin.",
    NOT_FOUND: "İstenen kayıt bulunamadı.",
    SERVICE_ERROR:
      "Servis geçici olarak kullanılamıyor. Lütfen tekrar deneyin.",
    GENERIC_ERROR: "İşlem tamamlanamadı. Lütfen tekrar deneyin.",
  },
  ar: {
    exit: "AR'dan çık",
    hint: "Yüzey arayın, ürünü sürükleyip döndürün",
    startedSearching: "AR başladı — yüzey aranıyor",
    preparingModel: "3D model hazırlanıyor…",
    openInAr: "AR'da aç",
    surfaceFound: "Yüzey bulundu",
    productPlaced: "Ürün yerleştirildi",
    rotating: "Döndürülüyor…",
    light: "Işık",
    depth: "Derinlik",
    checking: "Kontrol ediliyor",
    capabilityChecking: "{{label}} desteği kontrol ediliyor",
    capabilityOnTapToOff: "{{label}} aktif, kapatmak için dokun",
    capabilityOffTapToOn: "{{label}} kapalı, açmak için dokun",
    capabilityUnsupported: "{{label}} bu cihaz/tarayıcıda desteklenmiyor",
    lightEstimationActive: "Işık tahmini aktif",
    lightEstimationOn: "Işık tahmini açıldı",
    lightEstimationOff: "Işık tahmini kapandı",
    depthOcclusionActive: "Derinlik örtmesi aktif",
    depthOcclusionOn: "Derinlik örtmesi açıldı",
    depthOcclusionOff: "Derinlik örtmesi kapandı",
  },
  confirm: "Onayla",
  confirmshape: "Şekli Güncelle",
  notFound: "Bulunamadı",
  next: "İleri",
  back: "Geri",
  export: "Dışarı Aktar",
  search: "Ara",
  gapWidth: "Boşluk Genişliği",
  wallWidth: "Duvar Genişliği",
  balconyWidth: "Balkon Genişliği",
  clearAllTip: "Tümünü Temizle",
  drawBalconyTip: "Balkon Çiz",
  drawWallTip: "Duvar Çiz",
  selectToolTip: "Seç",
  drawGapTip: "Boşluk Çiz",
  downloadPdfTip: "PDF olarak indir",
  //WelcomeMenu.tsx
  welcomeMenuWelcome: "Merhaba!  Planlayıcıya Hoş Geldiniz!",
  drawRoomShape: "Kendi Odanı Çiz",
  chooseRoomShapeFromTemplates: "Hazır Şekillerden Seç",
  chooseRoomShape: "Oda Şeklini Seç",
  //MainPane.tsx
  roomFeatures: "Boyutlandır",
  roomStyle: "Oda Stili",
  door: {
    opensIn: "İçe açılır",
    opensOut: "Dışa açılır",
    hingeStart: "Menteşe (sol uç)",
    hingeEnd: "Menteşe (sağ uç)",
    openAngle: "Açılma açısı",
  },
  structural: {
    menu: "Yapı",
    rectColumn: "Dikdörtgen kolon",
    roundColumn: "Yuvarlak kolon",
    beam: "Kiriş",
    radiator: "Radyatör",
    pool: "Havuz",
    width: "Genişlik",
    depth: "Derinlik",
    height: "Yükseklik",
    diameter: "Çap",
    widthCm: "Genişlik (cm)",
    depthCm: "Derinlik (cm)",
    heightCm: "Yükseklik (cm)",
    diameterCm: "Çap (cm)",
    columnHeightLocked: "Yükseklik oda yüksekliğine kilitli",
    elevation: "Yükseklik kotu",
    elevationCm: "Yükseklik kotu (cm)",
    beamElevationHint: "Kiriş altının yerden yüksekliği. İlk yerleştirmede tavana yaslanır.",
    elevationHint: "Yerden yükseklik. 3D’de Yatay/Dikey ile taşıma yönünü seçin.",
    moveMode: "Taşıma",
    moveHorizontal: "Yatay",
    moveVertical: "Dikey",
    moveGizmo: "Eksenle taşı",
  },
  lighting: "Işık",
  settings: "Ayarlar",
  lengthUnit: "Ölçü birimi",
  lengthUnitCm: "Santimetre (cm)",
  lengthUnitMm: "Milimetre (mm)",
  lengthUnitInch: "İnç (in)",
  hdrSelection: "HDR Seçimi",
  hdrPreview: "HDR önizleme",
  renderSettings: "Görüntü",
  toneMapping: "Ton eşleme",
  disabled: "Kapalı",
  exposure: "Pozlama",
  environmentLight: "Çevre ışığı",
  aoMapIntensity: "AO haritası şiddeti",
  ambientOcclusion: "Ortam gölgeleme",
  ssgi: "SSGI",
  ssgiHint:
    "Ekran-uzayı GI + AO. Açıkken GTAO kapanır.",
  ssgiSparse: "SSGI Sparse",
  ssgiSparseHint:
    "Sadece GI (AO yok). Adım ızgarası; ara pikseller dört komşudan interpolasyon.",
  ssgiOutput: "Çıktı",
  ssgiOutputCombined: "Birleşik",
  ssgiOutputDirect: "Direkt",
  ssgiOutputAo: "AO",
  ssgiOutputGi: "GI",
  ssgiOutputNormal: "Normal (MRT)",
  ssgiOutputDepth: "Derinlik",
  ssgiOutputGiDebug: "GI Debug",
  ssgiOutputGiSource: "GI kaynağı",
  gtaoHint: "SSGI ve Path Trace kapalıyken kullanılabilir.",
  gtaoSamples: "Örnek sayısı",
  gtaoScale: "Ölçek",
  gtaoDenoise: "Denoise",
  gtaoLumaPhi: "Luma Φ",
  gtaoDepthPhi: "Depth Φ",
  gtaoNormalPhi: "Normal Φ",
  gtaoPdRadius: "Denoise yarıçapı",
  distanceExponent: "Mesafe üssü",
  distanceFallOff: "Mesafe düşüşü",
  resolutionScale: "Çözünürlük ölçeği",
  pixelRatioScale: "Çözünürlük kat sayısı",
  pixelRatioScaleHint:
    "Katsayı, tarayıcının devicePixelRatio değeri ile çarpılır. 1 = tam cihaz çözünürlüğü. Düşürmek netliği azaltır, FPS’i yükseltir.",
  imageQuality: "Görüntü kalitesi",
  qualitySmooth: "Akıcı",
  qualityBalanced: "Dengeli",
  qualitySharp: "Net",
  clarityHint: "Düşük netlik daha akıcı çalışır.",
  editLights: "Işıkları düzenle",
  advancedDisplay: "Gelişmiş görüntü",
  settingsSectionEnvironment: "Ortam",
  environmentFallback: "Ortam",
  pathTraceHint:
    "İlerlemeli path tracing (WebGL2 sidecar). Açıkken SSGI / GTAO / TAA kapanır.",
  pathTraceFrameCount: "Path Trace kare sayısı",
  pathTraceRenderScale: "Çözünürlük ölçeği",
  pathTraceBounces: "Sekme",
  pathTraceSamplesPerFrame: "Kare başı örnek",
  pathTraceFilterGlossy: "Parlak filtre",
  pathTraceFadeDuration: "Geçiş (ms)",
  sliceCount: "Dilim sayısı",
  stepCount: "Adım sayısı",
  giIntensity: "GI şiddeti",
  aoIntensity: "AO şiddeti",
  thickness: "Kalınlık",
  expFactor: "Exp faktör",
  backfaceLighting: "Arka yüz aydınlatma",
  useLinearThickness: "Doğrusal kalınlık",
  useScreenSpaceSampling: "Ekran uzayı örnekleme",
  useTemporalFiltering: "Zamansal filtre",
  giStride: "GI adımı",
  giAdaptive: "GI uyarlama",
  giAdaptiveOff: "Kapalı",
  giAdaptiveEdge: "Kenar",
  giAdaptiveRefine: "Refine",
  giAdaptiveRefineHint:
    "9 depth/normal tap’i uyuşmayan kaba hücrelerde full GI. Aşağıdaki derinlik ve normal eşiklerini kullanır.",
  giEdgeThickness: "GI kenar kalınlığı",
  giEdgeKernel: "GI kenar kernel",
  giEdgeKernelCross: "Çapraz (4 tap)",
  giEdgeKernelSobel: "Sobel",
  giEdgeKernelPrewitt: "Prewitt",
  giEdgeKernelScharr: "Scharr",
  giEdgeThreshold: "GI kenar eşiği",
  giDepthThreshold: "GI derinlik eşiği",
  giNormalThreshold: "GI normal eşiği",
  giMinOkCount: "Min geçerli tap",
  ssgiSparseVersion: "Sürüm",
  ssgiSparseVersionV1: "v1 (eski)",
  ssgiSparseVersionV2: "v2 (geçmişli)",
  ssgiSparseV2Hint:
    "GI + AO. Hücrede 1 piksel taranır, her kare başka piksel; sonuç yalnız GI'da birikir, yeni açılan yer yumuşatılır.",
  giHistoryLength: "Geçmiş uzunluğu (kare)",
  giDenoisePasses: "Yumuşatma turu",
  giEdgeRefine: "Kenarlarda ayrıca tara",
  intensity: "Şiddet",
  radius: "Yarıçap",
  raySamples: "Işın örnekleri",
  accumulation: "Birikim",
  denoise: "Gürültü azaltma",
  sampleLevel: "Örnek seviyesi",
  unbiased: "Tarafsız örnekleme",
  settingsSectionDisplay: "Görüntü",
  settingsSectionLighting: "Aydınlatma",
  settingsSectionColor: "Renk",
  antialias: "Anti-alias",
  antialiasSamples: "AA örnek",
  fxaa: "FXAA",
  msaa: "MSAA",
  msaaSamples: "MSAA örnek",
  shadows: "Gölgeler",
  shadowQuality: "Gölge kalitesi",
  qualityLow: "Düşük",
  qualityMedium: "Orta",
  qualityHigh: "Yüksek",
  resetRenderSettings: "Görüntü ayarlarını sıfırla",
  fullReset: "Tam sıfırla",
  help: "Yardım",
  volumeDebug: "Hacimler",
  cornerLineSnap: "Köşe hizası",
  volumeDebugCollision: "Çarpışma (sürüklerken)",
  volumeDebugObb: "OBB",
  volumeDebugAabb: "Bounding box",
  volumeDebugHint:
    "OBB’de iki renk: parça ve gövde. Çarpışma temas rengidir. Dünya kutusu eksenlere hizalı.",
  volumeDebugColorParts: "Parça rengi",
  volumeDebugColorHull: "Gövde rengi",
  volumeDebugColorContact: "Temas rengi",
  volumeDebugColorAabb: "Dünya kutusu rengi",
  appMode: "Mod",
  liveMode: "Live",
  devMode: "Dev",
  usageTips: "Kullanım ipuçları",
  restartTour: "Turu tekrar başlat",
  start: "Başlat",
  roomLights: "Oda ışıkları",
  roomLightsLoading: "Oda ışıkları hazırlanıyor…",
  height: "Yükseklik",
  spacing: "Aralık",
  distance: "Mesafe",
  decay: "Sönüm",
  color: "Renk",
  roomLightShadows: "Oda ışığı gölgesi",
  automatic: "Otomatik",
  reset: "Sıfırla",
  lightCount: "ışık",
  wallColor: "Duvar rengi",
  floorColor: "Zemin rengi",
  ceilingColor: "Tavan rengi",
  windowColor: "Pencere rengi",
  doorColor: "Kapı rengi",
  surfaceWall: "Duvar",
  surfaceFloor: "Zemin",
  surfaceCeiling: "Tavan",
  surfaceWindow: "Pencere",
  surfaceDoor: "Kapı",
  chooseFromColorPalette: "Renk Kartelasından seç",
  chooseFromColorPaletteHint: "Spektrumdan özel renk seç",
  floorMaterials: "Zemin kaplaması",
  floorMatParquet01: "Parke 01",
  floorMatParquet02: "Parke 02",
  floorMatParquet03: "Parke 03",
  floorMatParquet04: "Parke 04",
  floorMatParquet05: "Parke 05",
  floorMatParquet06: "Parke 06",
  floorMatParquet07: "Parke 07",
  floorMatParquet08: "Parke 08",
  floorMatParquet09: "Parke 09",
  floorMatParquet10: "Parke 10",
  floorMatParquet11: "Parke 11",
  floorMatParquet12: "Parke 12",
  floorMatParquet13: "Parke 13",
  floorMatParquet14: "Parke 14",
  floorMatParquet15: "Parke 15",
  floorMatParquet16: "Parke 16",
  floorMatParquet17: "Parke 17",
  floorMatParquet18: "Parke 18",
  floorMatParquet19: "Parke 19",
  floorMatParquet20: "Parke 20",
  floorMatParquet21: "Parke 21",
  floorMatParquet22: "Parke 22",
  floorMatOakParquet: "Meşe parke",
  floorMatWalnutParquet: "Ceviz parke",
  floorMatAshParquet: "Dişbudak parke",
  floorMatHoneyOak: "Bal meşe",
  floorMatDarkOak: "Koyu meşe",
  floorMatCherryParquet: "Kiraz parke",
  floorMatTeakParquet: "Tik parke",
  floorMatSmokedOak: "Füme meşe",
  floorMatOakHerringbone: "Meşe balık sırtı",
  floorMatWalnutHerringbone: "Ceviz balık sırtı",
  floorMatOakWidePlank: "Meşe geniş lama",
  floorMatWalnutWidePlank: "Ceviz geniş lama",
  floorMatAshWashedPlank: "Yıkanmış dişbudak",
  floorMatOakChevron: "Meşe chevron",
  floorMatBleachedOak: "Ağartılmış meşe",
  floorMatSilverWashedOak: "Gümüş yıkanmış meşe",
  floorMatWarmOak: "Sıcak meşe",
  floorMatBeigeGeoPanel: "Bej geometrik panel",
  floorMatCharcoalGeoPanel: "Antrasit geometrik panel",
  floorMatTravertineBeige: "Bej traverten",
  floorMatWhiteMarble: "Beyaz mermer",
  floorMatCarraraMarble: "Carrara mermer",
  floorMatGrayMarble: "Gri mermer",
  floorMatBlackMarble: "Siyah mermer",
  floorMatCalacattaMarble: "Calacatta mermer",
  floorMatVerdeMarble: "Yeşil mermer",
  floorMatTravertineMarble: "Traverten",
  floorMatRossoMarble: "Kırmızı mermer",
  floorMatLightTile: "Açık fayans",
  floorMatGrayTile: "Gri fayans",
  floorMatTerracottaTile: "Terracotta fayans",
  floorMatConcrete: "Beton",
  floorMatGrass: "Çimen",
  newSceneTip: "Yeni sahne",
  newSceneConfirmTitle: "Yeni sahne oluşturulsun mu?",
  newSceneConfirmBody: "Mevcut sahne tamamen boşaltılacaktır.",
  newSceneConfirm: "Sahneyi boşalt",
  selectFabricFromList: "Listeden Kumaş Seçiniz",
  sku: "SKU",
  cancelAction: "İptal",
  deleteSelectionTip: "Seçileni sil",
  drawWall: "Şablonlar",
  showReport: "Proformo",
  addToRoom: "Ürünler",
  authorizedCatalogUnauthorized: "Oturum gerekli.",
  authorizedCatalogEmpty: "Sonuç yok.",
  authorizedCatalogLoadMore: "Daha fazla yükle",
  authorizedFacetCatalogs: "Kataloglar",
  authorizedFacetCategories: "Kategoriler",
  authorizedFacetTypeCategories: "Tip kategorileri",
  authorizedFacetCollections: "Koleksiyonlar",
  authorizedClearFacets: "Temizle",
  authorizedFilters: "Filtreler",
  authorizedChooseFilterHint:
    "Filtre ikonundan katalog veya kategori seçin.",
  authorizedProductsTitle: "Ürünler",
  authorizedHideProducts: "Ürünleri gizle",
  cameraView: "Görünüm",
  cameraViewTop: "Üst",
  cameraViewLeft: "Sol",
  cameraViewRight: "Sağ",
  cameraViewTopHint: "Üstten bak",
  cameraViewLeftHint: "Yandan bak",
  cameraViewRightHint: "Önden bak",
  configure: "Konfigürasyon",
  //RoomShaping.tsx
  changeRoomShape: "Oda Şeklini Değiştir",
  roomShapeStartMessage:
    "Yaşam alanını birlikte tasarlayacağız! Ölçüleri girmeden önce, alanına en çok benzeyen şekli seç.",
  selectRoomTemplate: "Şablonu Seç",
  drawFromScratch: "Sıfırdan Çiz",
  newRoom: "Temizle",
  roomShapeOnlyFloor: "Duvarsız oda",
  roomShapeFloorWithSingleWall: "Tek Duvar",
  roomShapeCorner: "Köşe",
  roomShapeRectangle: "Dikdörtgen",
  roomShapeSquare: "Kare",
  roomShapeLShape: "L Şekli",
  roomShapeUShape: "U Şekli",
  roomShapeTShape: "T Şekli",
  roomShape5Sides: "5 Kenarlı",
  roomDoubleBalcony: "Köşe",
  roomShapeZShape: "Z Şekli",
  roomShapeBevelShape: "Kesik Şekli",

  //RoomModifying.tsx
  wallResize: "Duvarları Yeniden Boyutlandır",
  glassPriceMultiplier: "Cam Metre Fiyatı",
  basePriceMultiplier: "Taban Birim Fiyatı",
  buyerName: "Alıcı Adı",
  dimensions: "Boyutlar",
  resetArea: "Alanı Sıfırla",
  undo: "Geri Al",
  redo: "İleri Al",
  topView: "Üstten Görüş",
  createRender: "Render Al",
  calculating: "Hesaplanıyor...",
  loading: "Yükleniyor...",
  productList: "Ürün Listesi",
  pdfReport: {
    defaultProjectName: "tasarim-ozeti",
    designReport: "Tasarım Raporu",
    designSummary: "Tasarım Özetiniz",
    downloadPdf: "PDF",
    print: "Yazdır",
    share: "Paylaş",
    requestQuote: "Teklif Al",
    close: "Kapat",
    downloaded: "PDF indirildi.",
    contentNotFound: "Rapor içeriği bulunamadı",
    screenshotUnavailable: "Ekran görüntüsü alınamadı",
    addImage: "Görsel ekle",
    capturingViews: "Görüntüler hazırlanıyor…",
    removeImage: "Görseli kaldır",
    pickImage: "Görsel seç",
    products: "Ürünler",
    image: "Görsel",
    code: "Kod",
    sizeCm: "Boyut (cm)",
    noProducts: "Ürün bulunamadı",
    shareUnavailable: "Paylaşım için görsel bulunamadı.",
    buyerInfo: "ALICI BİLGİLERİ",
    phoneLabel: "TELEFON",
    address: "ADRES",
    billingAddress: "FATURA ADRESİ",
    billingSameAsCustomer: "Fatura adresi müşteri adresi ile aynıdır.",
    sectionOne: "Section 1",
    colIndex: "#",
    colProduct: "Ürün",
    colQty: "Adet",
    colUnit: "Birim",
    unitPiece: "Adet",
    colCustomized: "Özelleştirilmiş",
    colDiscount: "İndirim",
    colGrandTotal: "Genel Toplam",
    currency: "Para Birimi",
    emptyValue: "—",
  },
  proforma: {
    modelSummary: "Normod Tasarım Özeti",
    pdfGenerating: "PDF oluşturuluyor...",
    pdfLibraryError: "PDF kütüphanesi yüklenemedi",
    pdfError: "PDF oluşturulamadı. Lütfen tekrar deneyin.",
    pdfError2: "PDF oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.",
    offerNo: "Teklif No",
    quantity: "Adet",
    product: "Ürün",
    price: "Fiyat",
    subtotal: "Ara Toplam",
    dimensions: "Boyutlar",
    materialType: "Kumaş Tipi",
    materialColor: "Kumaş Rengi",
    orderDate: "Sipariş Tarihi",
    discount: "İndirim",
    taxIncluded: "Vergi(Dahil) KDV- 10%",
    total: "GENEL TOPLAM",
    footer1: "Fiyatlarımıza KDV dahildir.",
    footer2: "Fiyatlar formun oluşturulduğu gün için geçerlidir.",
    footer3: "Bu form teklif amaçlı olup sipariş amaçlı kullanılamaz.",
    footer4: "Bu tasarım kişiye özel olarak {{date}} tarihinde hazırlanmıştır.",
    footer5:
      "Ürünlerimiz konfor odaklı tasarlanmaktadır. Oldukça zengin elyaf ve elastikiyeti yüksek premium süngerler kullanıldığı için dikişler sert ve düz çizgiler şeklinde olmayabilir.",
    footer6: "Ekrandaki renkler ton değişiklikleri gösterebilir.",
    footer7: "Teklifin geçerlilik süresi 3 gündür.",
    preview3d: "3D Görünüm",
    setProjectName: "Proje Adını Belirleyin",
    pdfWillBeSavedAs: "PDF dosyası bu isimle kaydedilecektir",
    projectName: "Proje Adı",
    projectNamePlaceholder: "Örn: Mutfak Tasarımı",
    cancel: "İptal",
    createPdf: "PDF Oluştur",
    priceAsc: "Fiyat ↑",
    priceDesc: "Fiyat ↓",
    sort: "Sırala",
    productDetails: "Ürünün Detayları",
    cm: "cm",
    addToCart: "Sepete Ekle",
    share: "Paylaş",
  },
  tips: {
    doneBtnText: "Anladım",
    dontShowAgain: "Bir daha gösterme",
    onboarding: {
      welcomeTitle: "Room Designer'a Hoşgeldiniz!",
      welcomeDesc:
        "Yaşam alanını birlikte tasarlayacağız! Ölçüleri girmeden önce alanına en çok benzeyen şekli seçin, veya sıfırdan çizmeye başlayın.",
      canvasTitle: "Tasarım Alanınız",
      canvasDesc:
        "Odanızı burada görecek ve düzenleyeceksiniz. 2D modda duvar çizebilir, 3D modda ürünleri yerleştirip önizleme yapabilirsiniz.",
      toolbarTitle: "Araç Çubuğu",
      toolbarDesc:
        "Sol tarafta çizim araçları, pencere/kapı ekleme ve paneller burada. Şimdi tek tek bakalım.",
      viewModeTitle: "Görünüm Modu",
      viewModeDesc:
        "<b>2D</b>: Duvar çizimi ve plan görünümü.<br><b>3D</b>: Gerçekçi önizleme ve ürün yerleştirme. Aralarında geçiş yapabilirsiniz.",
      undoTitle: "Geri Al / İleri Al",
      undoDesc:
        "Yaptığınız işlemleri geri alabilir veya tekrar uygulayabilirsiniz.",
      drawWallTitle: "Duvar Çiz",
      drawWallDesc:
        "Bu aracı seçtikten sonra tasarım alanında tıklayarak duvar köşelerini belirleyin. Başlangıç noktasına tıklayarak odayı kapatabilirsiniz.",
      windowTitle: "Pencere Ekle",
      windowDesc:
        "Bu aracı seçtikten sonra duvar üzerine tıklayarak pencere ekleyebilirsiniz. Kapı aracı da hemen altındadır.",
      panelTitle: "Ürün Ekle",
      panelDesc:
        "Sol menüdeki bu butonla sağ paneli açıp mobilya ve aksesuar ekleyebilirsiniz. Panel şu an açık — ürünlere tıklayarak veya sürükleyerek ekleyin.",
      templatesTitle: "Şablonlar",
      templatesDesc:
        "Hazır şablonları istediğiniz zaman buradan açabilirsiniz.",
      resizeTitle: "Boyutlandır",
      resizeDesc:
        "Odayı buradan boyutlandırabilir, duvar kalınlığını değiştirebilirsiniz. Devam etmek için Next’e basın.",
      fullscreenTitle: "Tam Ekran",
      fullscreenDesc:
        "Daha geniş çalışma alanı için tam ekrana geçebilirsiniz. Açıp kapatmayı gösteriyoruz.",
      doorTitle: "Kapı Ekle",
      doorDesc:
        "Bu aracı seçtikten sonra duvar üzerine tıklayarak kapı ekleyebilirsiniz.",
      zoomTitle: "Yakınlaştır / Uzaklaştır",
      zoomDesc:
        "Sahneyi zoom out ve zoom in ile ölçekleyebilirsiniz.",
      quoteTitle: "Teklif Al",
      quoteDesc:
        "Tasarımınız hazır olduğunda buradan teklif talebi oluşturabilirsiniz. Teklif penceresi açık — kapatmak için Next’e basın.",
      categoriesTitle: "Oda Stili",
      categoriesDesc:
        "Duvar, zemin ve tavan renkleri ile zemin malzemelerini buradan değiştirebilirsiniz.",
      helpTitle: "Yardıma İhtiyacınız Olursa",
      helpDesc:
        "Bu butona tıklayarak bu turu istediğiniz zaman tekrar başlatabilirsiniz. İyi tasarımlar!",
    },
    contextual: {
      threeDModeTitle: "3D Görünümdesiniz",
      threeDModeDesc:
        "Sağ tıklayıp sürükleyerek kamerayı döndürebilirsiniz. Mouse tekerleği ile yakınlaştırıp uzaklaştırabilirsiniz.",
      drawerActiveTitle: "Çizim Modu Aktif",
      drawerActiveDesc:
        "Tasarım alanında tıklayarak köşe noktaları belirleyin. Çizimi tamamlamak için başlangıç noktasına tekrar tıklayın veya çift tıklayın.",
      productSelectedTitle: "Ürün Seçildi",
      productSelectedDesc:
        "Bu açılan menüden ürünü döndürebilir, silebilir veya başka bir ürünle değiştirebilirsiniz.",
      wallSelectedTitle: "Duvar Ayarları",
      wallSelectedDesc:
        "Bu pencereden duvar tipini değiştirebilir ve boyutları ayarlayabilirsiniz.",
      cornerButtonsTitle: "Duvar Ekleme Noktası",
      cornerButtonsDesc:
        "Bu '+' butonlarına tıklayarak mevcut köşelere yeni duvar ekleyebilirsiniz.",
      backTo2dTitle: "2D Moddasınız",
      backTo2dDesc:
        "Şimdi duvar çizebilir, duvar boyutlarını değiştirebilir ve plan görünümünde çalışmaya devam edebilirsiniz.",
    },
    progress: {
      roomCreatedTitle: "Odanız Hazır!",
      roomCreatedDesc:
        "Sol menüdeki ürün butonundan mobilya ve aksesuar ekleyebilirsiniz. Sürükle-bırak veya tıklayarak ekleyin.",
      firstProductTitle: "İlk Ürün Eklendi!",
      firstProductDesc:
        "Ürüne tıklayarak seçin, ardından döndürün, silin veya başkasıyla değiştirin. 3D görünüme geçip nasıl göründüğünü kontrol edin.",
      threeDPreviewTitle: "3D Önizleme Harika Görünüyor!",
      threeDPreviewDesc:
        "Oda Stili butonundan duvar, zemin ve tavan renklerini değiştirebilirsiniz.",
      materialChangedTitle: "Tasarımınız Şekilleniyor!",
      materialChangedDesc:
        "Hazır olduğunuzda teklif alarak veya PDF ile tasarımınızı paylaşabilirsiniz.",
      wallResizedTitle: "Duvar Boyutu Güncellendi",
      wallResizedDesc:
        "3D görünüme geçerek değişikliklerin nasıl göründüğünü kontrol edin.",
    },
  },
  side: {
    backCushion: "Sırt Minderi",
    armOption: "Kol Seçeneği",
    fabricDetails: "Kumaş Detayları",
    apply: "Uygula",
    materialGroupDescription:
      "Bulunan kumaş tiplerinden seç ve onun alt grubundan istediğin rengi seçip ürününü özelleştir.",
  },
};
